import { IQuestion } from './types';

export default class QuestionFactory {
  static Create(): IQuestion {
    return {
      text: '',
      yesMessage: '',
      noMessage: '',
      emailWhen: 0,
    };
  }
}
